import { useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Reveal } from "@/components/ui-bits";
import { QuoteForm } from "@/components/Forms";
import { PHONE_DISPLAY, EMAIL, waLink, track } from "@/lib/site";
import { Phone, Mail, MessageCircle, ClipboardCheck } from "lucide-react";
import { PROCESS_STEPS } from "@/lib/site";

export default function Quote() {
  const [params] = useSearchParams();
  const isSample = params.get("type") === "sample";

  return (
    <>
      <Seo
        title={isSample ? "Request a Sample — Orvella Overseas" : "Request a Quote — Indian Food Products B2B | Orvella Overseas"}
        description={isSample ? "Request product samples from Orvella Overseas. Share your requirement and our export team will arrange samples where applicable." : "Request a quotation for Indian food and agricultural products — rice, spices, makhana, tea, peanuts, dehydrated products and food powders. Orvella Overseas responds with specifications, packaging and commercial terms."}
        path="/quote"
      />

      <PageHero
        eyebrow={isSample ? "Sample Request" : "Request a Quote"}
        title={isSample ? "Request a Product Sample" : "Request a Quotation"}
        sub={isSample
          ? "Samples can be arranged where applicable. Share your requirement and our export team will confirm feasibility."
          : "Share your product, quantity and destination details — our export team will respond with specifications, packaging options and a commercial quotation."}
      />

      <section className="section-pad">
        <div className="container-x grid gap-10 lg:grid-cols-[1.5fr_1fr]">
          <Reveal>
            <QuoteForm type={isSample ? "sample" : "quote"} />
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5">
              <div className="card p-6" data-testid="quote-what-next-card">
                <h2 className="flex items-center gap-2 font-serif text-lg font-semibold text-navy">
                  <ClipboardCheck size={18} className="text-gold-dark" /> What happens next
                </h2>
                <ol className="mt-4 space-y-3 text-sm text-mist">
                  {PROCESS_STEPS.slice(0, 4).map((s) => (
                    <li key={s.n} className="flex gap-3">
                      <span className="font-serif font-semibold text-gold-dark">{s.n}</span>
                      <span><strong className="text-navy">{s.title}.</strong> {s.text}</span>
                    </li>
                  ))}
                </ol>
              </div>
              <div className="card p-6" data-testid="quote-contact-card">
                <h2 className="font-serif text-lg font-semibold text-navy">Prefer to talk first?</h2>
                <ul className="mt-4 space-y-3 text-sm">
                  <li>
                    <a href="tel:+919973519755" data-testid="quote-page-call-link" onClick={() => track("phone_click")} className="inline-flex items-center gap-2.5 font-semibold text-navy hover:text-gold-dark">
                      <Phone size={16} className="text-gold-dark" /> {PHONE_DISPLAY}
                    </a>
                  </li>
                  <li>
                    <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="quote-page-whatsapp-link" onClick={() => track("whatsapp_click")} className="inline-flex items-center gap-2.5 font-semibold text-navy hover:text-gold-dark">
                      <MessageCircle size={16} className="text-gold-dark" /> WhatsApp Us
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${EMAIL}`} data-testid="quote-page-email-link" onClick={() => track("email_click")} className="inline-flex items-center gap-2.5 font-semibold text-navy hover:text-gold-dark">
                      <Mail size={16} className="text-gold-dark" /> {EMAIL}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
